module.exports = __webpack_public_path__ + "img/loader.5d407a88.svg";